import React, { useState, useEffect, useRef, useContext } from 'react';
import { SettingsContext } from './AccountSettingsButton';
import Basic from './Basic'; 
import AccountIds from './AccountIds';
import Inflation from './Inflation';
import Access from './Access';
import Scripts from './Scripts';
import showAlert from 'utils/showAlert';

function AccountSettingsModal() {
  const modalRef = useRef();
  const context = useContext(SettingsContext);
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

  const [activeTab, setActiveTab] = useState('basicInfo');
 const inflation = context.inflation;

  const logo = context.client_logo ? <img className="client-logo" alt="Client logo" src={context.client_logo} /> : "";

  let xIcon = require("images/lite/icons/x-close.svg");
  xIcon = (
    <img className="close-icon" alt="remove" src={`/datapulse${xIcon}`} />
  );

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    context.toggleModal();

    const configForm = document.querySelector("#lite-config-form");

    const formData = new FormData();
    formData.append('company_name', context.companyName);
    formData.append('website', configForm['website'].value);
    formData.append('dashboard_objective', configForm.dashboard_objective.value);
    formData.append('overview_datasource', configForm.overview_datasource.value);
    formData.append('base_currency', configForm.base_currency.value);
    formData.append('display_currency', configForm.display_currency.value);
    formData.append('client_account_id', context.client_account.id);
    formData.append('client_logo', context.clientLogo);
    formData.append('google_ads_id', configForm.google_ads_id.value);
    formData.append('microsoft_id', configForm.microsoft_id.value);
    formData.append('meta_id', configForm.meta_id.value);
    formData.append('tiktok_id', configForm.tiktok_id.value);
    formData.append('google_analytics_id', configForm.google_analytics_id.value);
    formData.append('shopify_url', configForm.shopify_url.value);
    formData.append('shopify_revenue_type', configForm.shopify_revenue_type.value);
    formData.append('facebook_conversion_objective', configForm.facebook_conversion_objective.value);
    formData.append('tiktok_conversion_objective', configForm.tiktok_conversion_objective.value);
    formData.append('semrush_target_location', configForm.semrush_target_location.value);
    formData.append('semrush_id', configForm.semrush_id.value);
    formData.append('shopify_country_filter', configForm.shopify_country_filter.value);
    formData.append('amazon_ads_id', configForm.amazon_ads_id.value);
    formData.append('amazon_seller_country', configForm.amazon_seller_country.value);
    formData.append('google_sheets_url', configForm.google_sheets_url.value);
    formData.append('mailchimp_server_prefix', configForm.mailchimp_server_prefix.value);
    // Append script data
    formData.append("scripts[text_converting_query_mining_script]", configForm["scripts[text_converting_query_mining_script]"].checked ? "1" : "0");
    formData.append("scripts[em_bm_negative_overlap_script]", configForm["scripts[em_bm_negative_overlap_script]"].checked ? "1" : "0");
    formData.append("scripts[negative_dsa_sync_script]", configForm["scripts[negative_dsa_sync_script]"].checked ? "1" : "0");
    formData.append("scripts[keyword_cannibalization_script]", configForm["scripts[keyword_cannibalization_script]"].checked ? "1" : "0");

    // For nested script settings like exclude_nb_in_shopping
    formData.append('scripts[exclude_nb_in_shopping][enabled]', context.excludeNbInShopping ? '1' : '0');
    // formData.append('scripts[exclude_nb_in_shopping][keyword]', configForm['scripts[exclude_nb_in_shopping][keyword]'].value);
    Object.keys(context.excludeNbInShoppingKeywords).forEach(key => {
      formData.append(`scripts[exclude_nb_in_shopping][keyword][${key}]`, context.excludeNbInShoppingKeywords[key]);
    });

    // For youtube_channel_excluder
    formData.append("scripts[youtube_channel_excluder][enabled]", configForm["scripts[youtube_channel_excluder][enabled]"].checked ? "1" : "0");
    formData.append("scripts[youtube_channel_excluder][google_sheet]", configForm["scripts[youtube_channel_excluder][google_sheet]"].value);
    formData.append("scripts[youtube_channel_excluder][allowed_countries]", configForm["scripts[youtube_channel_excluder][allowed_countries]"].value);
    formData.append("scripts[youtube_channel_excluder][impressions_time_range]", configForm["scripts[youtube_channel_excluder][impressions_time_range]"].value);
    formData.append("scripts[youtube_channel_excluder][impressions_threshold]", configForm["scripts[youtube_channel_excluder][impressions_threshold]"].value);

    for (const platform in inflation) {
      for (const metric in inflation[platform]) {
        for (const day in inflation[platform][metric]) {
          const value = inflation[platform][metric][day];
          formData.append(`inflation[search][${platform}][${metric}][${day}]`, value);
        }
      }
    }

    //  client data
    context.clientUsers.forEach((user, index) => {
      if (user.id) {
        formData.append(`client_users[${index}][id]`, user.id);
      }
      formData.append(`client_users[${index}][role]`, user.role);
      formData.append(`client_users[${index}][department]`, user.department);
      formData.append(`client_users[${index}][email]`, user.email);
      formData.append(`client_users[${index}][first_name]`, user.first_name);
      formData.append(`client_users[${index}][last_name]`, user.last_name);
    });

    // employee data
    context.teamUsers.forEach((user, index) => {
      if (user.id) {
        formData.append(`team_users[${index}][id]`, user.id);
      }
      formData.append(`team_users[${index}][role]`, user.role);
      formData.append(`team_users[${index}][department]`, user.department);
      formData.append(`team_users[${index}][email]`, user.email);
      formData.append(`team_users[${index}][first_name]`, user.first_name);
      formData.append(`team_users[${index}][last_name]`, user.last_name);
    });

    
    try {
      const response = await fetch("/datapulse/lite-config/save-config", {
        method: "POST",
        headers: {
          "X-CSRF-Token": authenticityToken,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success == true) {
          console.log("Configuration saved successfully. Message from Server: ", data.message);
          showAlert(data.message);
        } else {
          console.error("Failed to save configuration", data.message);
          showAlert(data.message);
        }
      } else {
        console.error("Failed to save configuration. No message from server");
        showAlert("Failed to save configuration");
      }
    } catch (error) {
      console.error("Network error:", error);
      showAlert("Network error");
    }
  };

  const TabContent = () => (
    <div>
      <div style={{ display: activeTab === "basicInfo" ? "block" : "none" }}>
        <Basic />
      </div>
      <div style={{ display: activeTab === "accountIds" ? "block" : "none" }}>
        <AccountIds />
      </div>
      <div style={{ display: activeTab === "access" ? "block" : "none" }}>
        <Access />
      </div>
      <div style={{ display: activeTab === "inflation" ? "block" : "none" }}>
        <Inflation />
      </div>
      <div style={{ display: activeTab === "scripts" ? "block" : "none" }}>
        <Scripts />
      </div>
    </div>
  );

  useEffect(() => {
    if (context.isModalOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  
    // Cleanup function to ensure class is removed if the component unmounts
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [context.isModalOpen]);

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (!bottom) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  };

  return (
    <div className="modal-backdrop" onClick={context.toggleModal} style={{ display: context.isModalOpen ? "flex" : "none" }}>
      <form id="lite-config-form">
        <div className="lite-modal" onScroll={handleScroll} ref={modalRef} onClick={(e) => e.stopPropagation()}>
          <button type="button" className="close-button filter-grey" onClick={context.toggleModal}>{xIcon}</button>
          <div className="lite-top">
            <div className="lite-modal-header">
              <h3>Account Configuration</h3>
              <div className="client-info">
                {logo}
                <p className="client-name">{context.company_name}</p>
              </div>
            </div>
            <div className="lite-modal-content">
              <div className="lite-tabs">
                <button className={`lite-tab ${activeTab === "basicInfo" ? "tab-active" : ""}`} onClick={(e) => {e.preventDefault(); setActiveTab("basicInfo")}}>
                  Basic Info & Settings
                </button>
                <button className={`lite-tab ${activeTab === "accountIds" ? "tab-active" : ""}`} onClick={(e) => {e.preventDefault(); setActiveTab("accountIds")}}>
                  Account IDs
                </button>
                <button className={`lite-tab ${activeTab === "access" ? "tab-active" : ""}`} onClick={(e) => {e.preventDefault(); setActiveTab("access")}}>
                  Access
                </button>
                <button className={`lite-tab ${activeTab === "inflation" ? "tab-active" : ""}`} onClick={(e) => {e.preventDefault(); setActiveTab("inflation")}}>
                  Inflation
                </button>
                <button className={`lite-tab ${activeTab === "scripts" ? "tab-active" : ""}`} onClick={(e) => {e.preventDefault(); setActiveTab("scripts")}}>
                  Scripts
                </button>
              </div>
              <div className="lite-tab-content">
                <TabContent />
              </div>
            </div>
          </div>
          <div className="lite-modal-footer">
            <button type="button" className="cancel-button" onClick={context.toggleModal}>Cancel</button>
            <button
              type="submit"
              className="green-button"
              onClick={(e) => handleFormSubmit(e)}>
              ✔ Save changes
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AccountSettingsModal;
